<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height:65vh" @click.stop>
                <div class="dialog-title">
                    サブグループの編集
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <el-form label-width="150px">
                        <el-form-item prop="subGroupName" ref="subGroupName">
                            <div slot="label" style="text-align:left"><span v-t="'message.title_sub_group_name'"> <span class="required" v-t="'message.item_mandatory'"></span></div>
                            <span v-if="subGroupInfoType == 2">
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-t="'message.hint_modify_subGroupName_notice'"></div>
                                    <el-input id="subGroupName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.subGroupName.value" disabled="true"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                                </el-tooltip>
                            </span>
                            <span v-else>
                                <el-input id="subGroupName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.subGroupName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                             </span>
                        </el-form-item>
                    </el-form>
                    <div style="padding: 10px 0px 10px 0px;height:calc(100% - 67px)">
                        <div v-if="subGroupInfoType == 1" style="height:370px">
                            <div class="sub-selection-header">
                                <div class="inner-panel-title-left" v-t="'message.hint_destination_subgroup'">
                                </div>
                                <div class="inner-panel-title-right">
                                    <button class="transparent" @click="selectSubGroupAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                    <button class="transparent" @click="deselectSubGroupAll()" type="button"><span class="normal-command-text" v-t="'message.action_deselect_all'"></span></button>
                                </div>
                            </div>
                            <div style="padding-left:20px;padding-right:20px">
                                <table width="100%">
                                    <tr v-for="row in Const.SUB_GROUP_ROW_COUNT">
                                        <td width="25%" class="checkSubGroup" v-for="index in Const.SUB_GROUP_COLUMN_COUNT">
                                            <el-checkbox v-model="destinationSubGroup[((row-1)*Const.SUB_GROUP_COLUMN_COUNT) + index - 1].enabled" @change="disableButton=false">
                                                {{ talkGroupAttribute.subGroups[((row-1)*Const.SUB_GROUP_COLUMN_COUNT) + index - 1].displayName }}
                                            </el-checkbox>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div v-if="subGroupInfoType == 2" style="height:calc(100% - 70px)">
                            <el-form @submit.native.prevent="findUser()" style="padding-left:20px;padding-bottom:20px">
                                <el-radio-group v-model="listType" fill="#5171cb" @change="searchWord=''">
                                    <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                    <el-radio-button class="search-type-select" :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                </el-radio-group>
                                <el-input v-if="listType == Const.SELECT_SEARCH_USERS" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchWord" clearable class="user-search-select">
                                    <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                        <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                        <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                        <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                        <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                                    </el-select>
                                    <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                </el-input>
                            </el-form>
                            <table width="100%" height="100%">
                                <tr>
                                    <td width="50%" class="sub-selection-header">
                                        <div class="inner-panel-title-left" v-t="'message.common_action_select_user'">
                                        </div>
                                        <div v-if="listType == Const.SELECT_SEARCH_USERS" class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                        <div v-else class="inner-panel-title-right">
                                            <button class="transparent" @click="selectAllUsers()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                    </td>
                                    <td width="50%" class="sub-selection-header">
                                        <div class="inner-panel-title-left" v-t="'message.title_participating_user'">
                                        </div>
                                        <div v-if="listType == Const.SELECT_OBJECT_TREE" class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.common_action_delete_all'"></span></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="50%">
                                        <div v-if="listType == Const.SELECT_OBJECT_TREE" id="selected-user" class="inner-panel-dialog" style="height: 100%;">
                                            <el-tree v-if="showUserTree"
                                                class="dialog-tree"
                                                :props="properties"
                                                :load="loadNode"
                                                node-key="id"
                                                ref="userTree"
                                                lazy
                                                highlight-current
                                                default-expanded-keys="{1}"
                                                :expand-on-click-node="false"
                                                @node-click="handleNodeClick"
                                                :render-content="renderContent">
                                            </el-tree>
                                        </div>
                                        <div v-else class="inner-panel-dialog" style="height: 100%;">
                                            <div v-if="Object.keys(this.foundUserList).length==0" class="default-message" v-t="'message.info_input_searching_condition'">
                                            </div>
                                            <table width="100%">
                                                <tr class="foundUser-record" v-for="user in foundUserList" v-bind:key="user.tenantId + '_' + user.id" @click="addTag(user)">
                                                    <div v-if="tenantList.length == 1">
                                                        <td class="foundUser">{{ user.userName }} / {{ user.displayName }}</td>
                                                    </div>
                                                    <div v-else>
                                                        <td class="foundUser" width="250px">{{ user.userName }} / {{ user.displayName }}</td>
                                                        <td class="foundUser" width="250px">{{ user.tenantName }}</td>
                                                    </div>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                    <td width="50%" style="vertical-align:top">
                                        <div class="selected-item-field" style="overflow:auto;height:calc(100% - 10px)">
                                            <div class="default-message" v-if="Object.keys(editTagList) == 0" v-html="$t('message.hint_add_selected_user_from_left_pane')">
                                            </div>
                                            <span v-for="tag in editTagList" v-bind:key="tag.id">
                                                <div class="userTag">
                                                    <span class="userTag-name">{{ tag.displayName }}</span>
                                                    <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button  class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import UserSelection from "./UserSelection.vue"
import charactercheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            Const: {
                TAB_DEST_SUB_GROUP: "destSubGroup",
                TAB_JOINED_USERS: "joinedUsers",
                SELECT_OBJECT_TREE: 0,
                SELECT_SEARCH_USERS: 1,
                MAX_SUB_GROUP_COUNT: 32,
                SUB_GROUP_ROW_COUNT: 8,
                SUB_GROUP_COLUMN_COUNT: 4,
            },
            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
            showUserTree: true,
            showSelectionBox: true,
            listType: 0,
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            disableButton: true,
            tenantList: [],
            foundUserList: {},
            joinedUsersOfGroup: [],
            selectedEditType: null,
            selectedTabName: null,
            inputForm: {
                subGroupName: { validationRule: "reqDisplayName", valid: true, value: null, isComposing: false },
                valid: [ true ]
            },
            destinationSubGroup: [],
            loadingScreen: null,
            searchWord: null,
            condition: null
        };
    },
    methods: {
    	handleNodeClick(data, node, elNode) {
            if ((data.id == 1) || (data.tenantId != this.appData.tenantList[0].tenantId)) {
                return;
            }
            if (data.type == constants.OBJECT_USER) {
                let key = data.tenantId + "-" + data.id;
                if (!(key in this.editTagList)) {
                    this.addTag(data);
                } else {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                }
            }
        },
        reload() {
            this.showUserTree = false;
            this.$nextTick(() => {
                 this.showUserTree = true
            })
        },
        loadNode(node, resolve) {
            if (node.parent == null) {
                let data = [];
                data.push({ id: 1, label: this.talkGroupAttribute.displayName, type: constants.OBJECT_TALKGROUP, isLeaf: false });
                resolve(data);
                return;
            }

            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            this.joinedUsersOfGroup = [];
            server.post('/getusertalkgroupinfo', { talkgroupTenantId: this.appData.tenantList[0].tenantId, id: this.talkGroupAttribute.id })
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                    case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                        let sortedUserTalkGroup = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_USER).sortedUserTalkGroup;
                        for (let userTalkgroup of sortedUserTalkGroup) {
                            if (userTalkgroup.userTenantId != this.appData.tenantList[0].tenantId) {
                                continue;
                            }
                            let key = userTalkgroup.userTenantId + '-' + userTalkgroup.userId;
                            let tagInfo = {
                                    id: key,
                                    tenantId: userTalkgroup.tenantId ,
                                    talkgroupId: userTalkgroup.talkgroupId ,
                                    userTenantId: userTalkgroup.userTenantId ,
                                    userId: userTalkgroup.userId ,
                                    userName: userTalkgroup.userName ,
                                    displayName: userTalkgroup.displayName,
                                    label: userTalkgroup.userName + " / " + userTalkgroup.displayName,
                                    type: constants.OBJECT_USER,
                                    isLeaf: true
                            };
                            if (userTalkgroup.joinedSubGroupIdList.includes(self.subGroup.subGroupId)) {
                                Vue.set( self.editTagList, key, tagInfo);
                                Vue.set( self.orgTagList, key, tagInfo);
                            }
                            self.joinedUsersOfGroup.push(tagInfo);
                        }
                        resolve(self.joinedUsersOfGroup);
                        self.closeLoadingScreen();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                        self.closeLoadingScreen();
                        return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                self.closeLoadingScreen();
            });
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            switch(data.type) {
                case constants.OBJECT_USER:
                    objectIcon = require("../assets/user.svg");
                    break;
                case constants.OBJECT_TALKGROUP:
                    objectIcon = require("../assets/group.svg");
                    break;
            }
            return h("span", { style: { display: "flex" } }, [h("img", { attrs: { src: objectIcon ,height: "20px" , style: "vertical-align: middle" } }), h("span",node.label)]);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.disableButton = false;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableButton = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        InputCheckAll() {
            this.inputCheck("subGroupName");
        },
        selectAllUsers() {
            for (let node of this.$refs.userTree.root.childNodes[0].childNodes) {
                if (node.data.type == constants.OBJECT_USER) {
                    if (!(node.data.id in this.editTagList)) {
                        this.addTag(node.data);
                    }
                }
            }
        },
        selectTagAll: function() {
            let addUserCount = 0;
            for (let key in this.foundUserList) {
                this.addTag(this.foundUserList[key])
                addUserCount ++;
            }
            if (addUserCount != Object.keys(this.foundUserList).length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_user")));
            }
        },
        addTag(user) {
            let key = user.tenantId + '-' + user.userId
            if (key in this.editTagList) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                return;
            }
            Vue.set(this.editTagList, key, user)
            if (!(key in this.orgTagList)) {
                Vue.set(this.addTagList, key, user);
            }
            Vue.delete(this.removeTagList, key);
            this.disableButton = false;
        },
        removeUserTag: function(tag) {
            // check remove-all condition
            switch(this.selectionType) {
                case constants.USER_SELECTION_ACL_RW:
                    if ((this.forbidAllDelete) && (Object.keys(this.editTagList).length == 1)) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_need_rw_user_on_root"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_GROUP_OF_USER:
                    if (this.existImportGroup) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_all_user_by_link"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_TENANT_ADMIN:
                    if (Object.keys(this.editTagList).length == 1) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_no_users"));
                        return;
                    }
                    for (let tenant of this.appData.importedTenantList) {
                        if (tenant.wantUserName == tag.userName) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_tenantAdmin"));
                            return;
                        }
                    }
            }

            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }
            Vue.delete(this.editTagList, tag.id)
            Vue.delete(this.addTagList, tag.id);
            this.disableButton = false;
        },
        removeAllUserTag() {
            switch(this.selectionType) {
                case constants.USER_SELECTION_ACL_RW:
                    if (this.forbidAllDelete) {
                        commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_all_users"));
                        return;
                    }
                    break;
                case constants.USER_SELECTION_TENANT_ADMIN:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_revoke_rights_by_no_users"));
                    return;
            }
            for (let key in this.editTagList) {
                if ((key in this.orgTagList)) {
                    Vue.set(this.removeTagList, key, this.editTagList[key]);
                }
            }
            this.editTagList = {};
            this.addTagList = {};
            this.disableButton = false;
        },
        findUser: function() {
            let dataList = [];
            for(let i = 0; i < this.tenantList.length; i++) {
                let param = {tenantId: this.tenantList[i].tenantId}
                if (this.condition == "name") {
                    param.name = this.searchWord;
                } else if (this.condition == "displayName") {
                    param.displayName = this.searchWord;
                } else if (this.condition == "organization") {
                    if (this.searchWord != "") {
                        param.organization = this.searchWord;
                    }
                } else if (this.condition == "title") {
                    if (this.searchWord != "") {
                        param.title = this.searchWord;
                    }
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_search_condition_not_found"));
                    return;
                }
                dataList.push(param)
            }

            let self = this;
            self.foundUserList = {}
            let getUserList = {}
            let tooManyUsers = false;
            let getResultCount = 0;
            for (let i = 0; i < dataList.length; i++) {
                let data = dataList[i]
                server.post('/finduser', data)
                    .then((res) => {
                        getResultCount ++;
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                break;
                            case constants.STATUS_ERROR_TOO_MANY_ENTRY:
                                tooManyUsers = true;
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findUser").replace("{code}",res.data.status));
                                return;
                        }
                        let tenantName = commonUtil.getTenantName(self.appData, data.tenantId);
                        for (let i = 0; i < res.data.userInfo.length; i++) {
                            let userInfo = res.data.userInfo[i]
                            let joinedUser = self.talkGroupAttribute.users.filter(function(userTalkGroup) {
                                console.log(data.tenantId,userTalkGroup.tenantId, userInfo.id, userTalkGroup.id,((userInfo.tenantId == userTalkGroup.tenantId) && (userInfo.id == userTalkGroup.id)));
                                return ((data.tenantId == userTalkGroup.tenantId) && (userInfo.id == userTalkGroup.id));
                            });
                            if (joinedUser.length > 0) {
                                let key = data.tenantId + '-' + userInfo.id
                                Vue.set(getUserList, key, {
                                        id: key,
                                        userTenantId: data.tenantId,
                                        userId: userInfo.id,
                                        tenantName: tenantName ,
                                        userName: userInfo.name ,
                                        userOptions: userInfo.userOptions ,
                                        defaultFlag: false,
                                        displayName: userInfo.displayName,
                                        orgRestrictions: userInfo.restrictions,
                                        orgRights: userInfo.rights
                                });
                            }
                        }
                        if (getResultCount == this.tenantList.length) {
                            if (tooManyUsers) {
                                self.foundUserList = {};
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"info_too_many_users"));
                                return;
                            }
                            if (Object.keys(getUserList).length == 0) {
                                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                                return;
                            }

                            // set sorted result to user-list
                            var tempArray = [];
                            for (let objectKey in getUserList) {
                                tempArray.push(objectKey);
                            }
                            tempArray.sort(function(a,b){
                                if( a < b ) return -1;
                                if( a > b ) return 1;
                                return 0;
                            });
                            for (var i = 0; i < tempArray.length; i++) {
                                Vue.set(self.foundUserList, tempArray[i], getUserList[tempArray[i]]);
                            }
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "findUser", error);
                    });
            }
        },
        selectSubGroupAll() {
            for (let index = 0 ; index < this.Const.MAX_SUB_GROUP_COUNT ; index ++) {
                this.destinationSubGroup[index].enabled = true;
            }
            this.disableButton = false;
        },
        deselectSubGroupAll() {
            for (let index = 0 ; index < this.Const.MAX_SUB_GROUP_COUNT ; index ++) {
                this.destinationSubGroup[index].enabled = false;
            }
            this.disableButton = false;
        },
        saveChange() {
            let modifySubGroupParam = [];
            let newDisplayName = null;
            if (this.inputForm.subGroupName.value != this.subGroup.displayName) {
                newDisplayName = this.inputForm.subGroupName.value;
            }
            switch(this.subGroupInfoType) {
                case constants.SUB_GROUP_INFO_DESTINATIONS:
                    let newSubGroupIdList = [];
                    for (let index = 0 ; index < this.Const.MAX_SUB_GROUP_COUNT ; index ++) {
                        if (this.destinationSubGroup[index].enabled) {
                            newSubGroupIdList.push(index + 1);
                        }
                    }
                    if (this.isModified()) {
                        let modifyParam = { command: "modifysubgroup", operation: {} };
                        modifyParam.operation.talkgroupId = this.talkGroupAttribute.id;
                        modifyParam.operation.subGroupId = this.subGroup.subGroupId;
                        if (newDisplayName != null) {
                            modifyParam.operation.newDisplayName = newDisplayName;
                        }
                        modifyParam.operation.newTargetSubGroupIdList = newSubGroupIdList;
                        modifySubGroupParam.push(modifyParam);
                    }
                    break;
                case constants.SUB_GROUP_INFO_USERS:
                    let subGroupIdList = [];
                    subGroupIdList.push(this.subGroup.subGroupId);
                    for (let key in this.addTagList) {
                        let userGroupInfo = this.addTagList[key];
                        modifySubGroupParam.push({
                            command: "addtosubgroup",
                            operation: {
                                userTenantId:userGroupInfo.userTenantId,
                                userId:userGroupInfo.userId,
                                tenantId:this.appData.tenantList[0].tenantId,
                                talkgroupId:this.talkGroupAttribute.id,
                                subGroupIdList: subGroupIdList
                            }
                        });
                    }
                    for (let key in this.removeTagList) {
                        let userGroupInfo = this.removeTagList[key];
                        modifySubGroupParam.push({
                            command: "removefromsubgroup",
                            operation: {
                                userTenantId:userGroupInfo.userTenantId,
                                userId:userGroupInfo.userId,
                                tenantId:this.appData.tenantList[0].tenantId,
                                talkgroupId:this.talkGroupAttribute.id,
                                subGroupIdList: subGroupIdList
                            }
                        });
                    }
                    break;
            }
            this.$emit('save', modifySubGroupParam);
        },
        isModified() {
            if (this.inputForm.subGroupName.value != this.subGroup.displayName) {
                return true;
            }
            for (let index = 0 ; index < this.Const.MAX_SUB_GROUP_COUNT ; index ++) {
                if (this.destinationSubGroup[index].enabled) {
                    if (!this.subGroup.targetSubGroupIdList.includes(index+1)) {
                        return true;
                    }
                } else {
                    if (this.subGroup.targetSubGroupIdList.includes(index+1)) {
                        return true;
                    }
                }
            }
            return false;
        },
        closeLoadingScreen() {
            this.loadingScreen.close();
            this.loadingScreen = null;
        },
        reDrawSelectionBox() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showSelectionBox = false;
            this.$nextTick(() => {
                 this.showSelectionBox = true
            })
        },
    },
    created: function() {
        this.selectedTabName = this.Const.TAB_DEST_SUB_GROUP;
        this.selectedEditType = this.Const.SELECT_OBJECT_TREE;
        this.tenantList.push(this.appData.tenantList[0]);
        for (let importedTenant of this.appData.importedTenantList) {
            if (importedTenant.state == constants.TENANT_CONNECT_ESTABLISH) {
                this.tenantList.push({
                        tenantId: importedTenant.tenantId,
                        id: 1,
                        label: importedTenant.tenantName,
                        name: importedTenant.tenantName,
                        type: 0,
                        isLeaf: false,
                        connectUserId: importedTenant.wantUserId
                    });
            }
        }
        this.inputForm.subGroupName.value = this.subGroup.displayName;
        for (let index = 0 ; index < this.Const.MAX_SUB_GROUP_COUNT ; index ++) {
            if (this.subGroup.targetSubGroupIdList.includes(index+1)) {
                this.destinationSubGroup.push({ enabled: true });
            } else {
                this.destinationSubGroup.push({ enabled: false });
            }
        }
    },
    watch: {
        searchWord(newVal) {
            if (newVal == "") {
                this.foundUserList = {};
            }
        },
    },
    components: {
    },
    props: [ 'appData', 'talkGroupAttribute', 'subGroup' , 'subGroupInfoType' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-input-field {
    height: 60px;
}

.inner-panel-addgroup {
	position:relative;
    height: calc(80vh - 250px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.dialog-body >>> .el-form-item {
    display: inline-block;
    color: #000000;
    height: 50px;
    width: 330px;
    padding-top: 10px;
    padding-left: 20px;
    margin-bottom: 10px;
}

.dialog-body >>> .el-radio-button__orig-radio:checked+.el-radio-button__inner{
    width: 145px;
    font-size: 12px;
}
.dialog-body >>> .el-radio-button:first-child .el-radio-button__inner {
    width: 145px;
    font-size: 12px;
}
.dialog-body >>> .el-radio-button:last-child .el-radio-button__inner {
    width: 145px;
    font-size: 12px;
}

.sub-selection-header {
    height: 20px;
    font-size: 12px;
    padding: 10px 20px 10px 20px;
    color: #848991;
    background-color: #f5f7fa;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #fff;
}
.el-tabs__nav-scroll {
    background: #fff;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #fff;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: solid 1px #eee;
}

.checkSubGroup {
    padding:10px;
}
.checkSubGroup >>> .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266;
}

.user-search-select {
    width: 600px;
}
.user-search-select >>> .el-input-group__prepend {
    background-color: #f5f7fa;
}
.user-search-select >>> .el-button {
    width: 80px;
    padding: 0;
    font-size: 12px;
}
.user-search-select >>> .el-input__inner {
    font-size: 12px;
    padding-left: 10px;
}
.user-search-select.el-input-group {
    font-size: 12px;
    padding-left: 20px;
    padding-bottom: 0;
}

.foundUser-record {
  cursor: pointer;
  word-break: break-all;
}
.foundUser-record:hover {
  background-color: #ecf1fa;
}

.foundUser {
  padding: 10px 20px;
}

.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

